import styled from 'styled-components'
import success from '~assets/images/checkSuccess.gif'

export default styled.img.attrs({
  src: success,
  height: 250,
})`
  user-select: none;
`
